// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-page {
    color: var(--mg-ink);
    margin: 0 auto;
    max-width: none;
    padding: 16px 18px 64px;
}

.product-layout {
    display: grid;
    column-gap: clamp(24px, 3vw, 52px);
    row-gap: 0;
    grid-template-columns: minmax(0, 1.85fr) minmax(340px, 1fr);
    margin-top: 14px;
}

.product-gallery {
    min-width: 0;
    position: relative;
}

.product-gallery__grid {
    display: grid;
    gap: clamp(8px, .85vw, 14px);
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.product-gallery__item {
    appearance: none;
    background: #f1f1f1;
    border: 0;
    cursor: zoom-in;
    display: block;
    overflow: hidden;
    padding: 0;
    width: 100%;
}

.product-gallery__image {
    aspect-ratio: 1 / 1;
    display: block;
    object-fit: contain;
    width: 100%;
}

.product-info {
    align-self: start;
    padding: clamp(36px, 3.5vw, 68px) clamp(8px, 2vw, 34px);
    position: sticky;
    top: 132px;
}

.product-info__brand {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    margin-bottom: 6px;
    text-transform: uppercase;
}

.product-info__title {
    font-family: var(--mg-sans);
    font-size: clamp(20px, 1.8vw, 28px);
    font-weight: 400;
    line-height: 1.25;
    margin: 0;
}

.product-condition,
.product-size,
.product-availability {
    color: #625f5a;
    font-size: 14px;
    line-height: 1.6;
}

.product-condition {
    margin: 8px 0 0;
}

.product-price {
    font-size: 17px;
    font-weight: 500;
    margin-top: 16px;
}

.product-size {
    border-bottom: 1px solid rgba(17, 17, 17, 0.1);
    margin: 12px 0 0;
    padding-bottom: 14px;
}

.product-availability {
    margin-top: 12px;
}

.product-availability p {
    margin: 0 0 10px;
}

.product-primary-action {
    background: #111111;
    border: 1px solid #111111;
    color: #ffffff;
    cursor: pointer;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.08em;
    min-height: 54px;
    padding: 0 24px;
    text-transform: uppercase;
    width: 100%;
}

.product-primary-action:hover:not(:disabled) {
    background: #ffffff;
    border-color: #111111;
    color: #111111;
}

.product-primary-action:disabled {
    cursor: not-allowed;
    opacity: 0.45;
}

.product-details {
    border-top: 1px solid rgba(17, 17, 17, 0.1);
    margin-top: 20px;
    padding-top: 18px;
}

.product-info__heading {
    align-items: start;
    display: grid;
    gap: 16px;
    grid-template-columns: minmax(0, 1fr) auto;
}

.product-info__heading .favourite-button {
    margin-top: -8px;
}

.product-details h2 {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.12em;
    margin: 0 0 8px;
    text-transform: uppercase;
}

.product-details p {
    color: #4f4c48;
    font-size: 14px;
    line-height: 1.55;
    margin: 0;
}

.product-description {
    color: #4f4c48;
    font-size: 14px;
    line-height: 1.55;
}

.product-details__meta {
    border-top: 1px solid rgba(17, 17, 17, 0.1);
    display: grid;
    font-size: 13px;
    gap: 7px 16px;
    grid-template-columns: minmax(96px, auto) 1fr;
    margin: 16px 0 0;
    padding-top: 14px;
}

.product-details__meta dt {
    color: #77736e;
}

.product-details__meta dd {
    margin: 0;
    text-align: right;
}

p.product-description {
    white-space: pre-line;
}

.product-description p,
.product-description div,
.product-description ul,
.product-description ol,
.product-description blockquote {
    margin: 0 0 12px;
}

.product-description ul,
.product-description ol {
    padding-left: 20px;
}

.product-description h2,
.product-description h3,
.product-description h4 {
    color: #111111;
    margin: 18px 0 8px;
}

.product-description > :last-child {
    margin-bottom: 0;
}

.product-description button {
    background: transparent;
    border: 1px solid rgba(17, 17, 17, 0.18);
    color: #111111;
    display: inline-flex;
    font: inherit;
    margin: 4px 8px 4px 0;
    padding: 7px 10px;
}

.product-description a {
    color: #111111;
    text-decoration: underline;
    text-underline-offset: 3px;
}

.product-modal {
    align-items: center;
    background: #f4f3f0;
    display: flex;
    inset: 0;
    justify-content: center;
    padding: 20px;
    position: fixed;
    z-index: 1000;
    animation: product-modal-enter 0.45s ease both;
}

.product-modal__content {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    max-height: 100%;
    max-width: none;
    overflow: hidden;
    position: relative;
    touch-action: none;
    width: 100%;
}

.product-modal__image {
    display: block;
    max-height: calc(100vh - 40px);
    max-width: calc(100% - 180px);
    object-fit: contain;
    cursor: zoom-in;
    transform: scale(1);
    transform-origin: center;
    transition: transform .65s cubic-bezier(.16,1,.3,1);
    -webkit-user-select: none;
            user-select: none;
}

.product-modal__content.is-zoomed .product-modal__image { cursor: zoom-out; transform: scale(1.65); }

.product-modal__arrow,
.product-modal__close {
    align-items: center;
    background: transparent;
    border: 0;
    border-radius: 0;
    color: #111111;
    cursor: pointer;
    display: flex;
    justify-content: center;
    position: absolute;
    transition: color .2s ease, opacity .2s ease;
    z-index: 1;
}

.product-modal__arrow:hover,
.product-modal__close:hover {
    background: transparent;
    color: #111111;
    opacity: .5;
}

@keyframes product-modal-enter {
    from { opacity: 0; }
    to { opacity: 1; }
}

.product-modal__arrow {
    background: transparent;
    border: 0;
    height: 42px;
    position: static;
    width: 42px;
}

.product-modal__arrow svg { height: 25px; stroke-width: 1.8; width: 25px; }
.product-modal__navigation { bottom: 20px; display: flex; flex-direction: column; gap: 2px; position: absolute; right: 18px; z-index: 3; }

.product-modal__close {
    height: 40px;
    right: 18px;
    top: 18px;
    width: 40px;
}

@media (max-width: 820px) {
    .product-page {
        padding: 16px 12px 40px;
    }

    .product-layout {
        grid-template-columns: 1fr;
    }

    .product-info {
        padding: 12px 6px 0;
        position: static;
    }

    .product-gallery__grid {
        display: flex;
        gap: 8px;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        scrollbar-width: none;
    }

    .product-gallery__grid::-webkit-scrollbar {
        display: none;
    }

    .product-gallery__item {
        flex: 0 0 88%;
        scroll-snap-align: start;
    }
}

.product-modal__close svg { height: 25px; stroke-width: 1.8; width: 25px; }

.product-modal__thumbnails { align-items: stretch; background: transparent; display: flex; flex-direction: column; gap: 18px; left: 18px; max-height: calc(100% - 64px); overflow-x: hidden; overflow-y: auto; overscroll-behavior: contain; padding: 0 8px 0 0; position: absolute; scrollbar-width: none; top: 50%; transform: translateY(-50%); width: 92px; z-index: 2; }
.product-modal__thumbnails::-webkit-scrollbar { display: none; }
.product-modal__thumbnail { background: transparent; border: 0; border-left: 2px solid transparent; cursor: pointer; flex: 0 0 104px; height: 104px; opacity: .48; overflow: hidden; padding: 0 0 0 7px; transition: border-color .25s ease, opacity .25s ease; width: 82px; }
.product-modal__thumbnail:hover { opacity: .82; }
.product-modal__thumbnail.is-active { border-left-color: #171717; opacity: 1; }
.product-modal__thumbnail img { height: 100%; object-fit: contain; width: 100%; }

@media (max-width: 540px) {
    .product-layout {
        gap: 20px;
        margin-top: 12px;
    }

    .product-modal {
        padding: 8px;
    }

    .product-modal__arrow {
        height: 40px;
        width: 40px;
    }

    .product-modal__image { max-height: calc(100dvh - 16px); max-width: calc(100% - 68px); }
    .product-modal__thumbnails { gap: 10px; left: 2px; max-height: calc(100% - 40px); padding-right: 4px; width: 60px; }
    .product-modal__thumbnail { flex: 0 0 68px; height: 68px; padding-left: 4px; width: 56px; }
    .product-modal__navigation { bottom: 8px; right: 4px; }
    .product-modal__close { right: 4px; top: 4px; }
}

@media (prefers-reduced-motion: reduce) {
    .product-modal__arrow,
    .product-modal__close {
        transition: none;
    }

    .product-modal {
        animation: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/ProductCard/ProductCard.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,cAAc;IACd,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,UAAU;IACV,2DAA2D;IAC3D,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,gDAAgD;AACpD;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,uDAAuD;IACvD,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,mCAAmC;IACnC,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;AACb;;AAEA;;;IAGI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,8CAA8C;IAC9C,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,2CAA2C;IAC3C,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;IAC3C,aAAa;IACb,eAAe;IACf,aAAa;IACb,6CAA6C;IAC7C,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;;;IAKI,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA;;;IAGI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;IACvB,wCAAwC;IACxC,cAAc;IACd,oBAAoB;IACpB,aAAa;IACb,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,aAAa;IACb,eAAe;IACf,aAAa;IACb,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,8BAA8B;IAC9B,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,wBAAwB;IACxB,mDAAmD;IACnD,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA,0DAA0D,gBAAgB,EAAE,sBAAsB,EAAE;;AAEpG;;IAEI,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,4CAA4C;IAC5C,UAAU;AACd;;AAEA;;IAEI,uBAAuB;IACvB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,UAAU,EAAE;AACrB;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,YAAY;IACZ,gBAAgB;IAChB,WAAW;AACf;;AAEA,4BAA4B,YAAY,EAAE,iBAAiB,EAAE,WAAW,EAAE;AAC1E,6BAA6B,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,kBAAkB,EAAE,WAAW,EAAE,UAAU,EAAE;;AAEzI;IACI,YAAY;IACZ,WAAW;IACX,SAAS;IACT,WAAW;AACf;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,QAAQ;QACR,gBAAgB;QAChB,6BAA6B;QAC7B,qBAAqB;IACzB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,wBAAwB;IAC5B;AACJ;;AAEA,4BAA4B,YAAY,EAAE,iBAAiB,EAAE,WAAW,EAAE;;AAE1E,6BAA6B,oBAAoB,EAAE,uBAAuB,EAAE,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE,UAAU,EAAE,6BAA6B,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE,kBAAkB,EAAE,kBAAkB,EAAE,qBAAqB,EAAE,QAAQ,EAAE,2BAA2B,EAAE,WAAW,EAAE,UAAU,EAAE;AAC5W,gDAAgD,aAAa,EAAE;AAC/D,4BAA4B,uBAAuB,EAAE,SAAS,EAAE,kCAAkC,EAAE,eAAe,EAAE,eAAe,EAAE,aAAa,EAAE,YAAY,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,qDAAqD,EAAE,WAAW,EAAE;AAC7Q,kCAAkC,YAAY,EAAE;AAChD,sCAAsC,0BAA0B,EAAE,UAAU,EAAE;AAC9E,gCAAgC,YAAY,EAAE,mBAAmB,EAAE,WAAW,EAAE;;AAEhF;IACI;QACI,SAAS;QACT,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA,wBAAwB,+BAA+B,EAAE,4BAA4B,EAAE;IACvF,6BAA6B,SAAS,EAAE,SAAS,EAAE,6BAA6B,EAAE,kBAAkB,EAAE,WAAW,EAAE;IACnH,4BAA4B,cAAc,EAAE,YAAY,EAAE,iBAAiB,EAAE,WAAW,EAAE;IAC1F,6BAA6B,WAAW,EAAE,UAAU,EAAE;IACtD,wBAAwB,UAAU,EAAE,QAAQ,EAAE;AAClD;;AAEA;IACI;;QAEI,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".product-page {\n    color: var(--mg-ink);\n    margin: 0 auto;\n    max-width: none;\n    padding: 16px 18px 64px;\n}\n\n.product-layout {\n    display: grid;\n    column-gap: clamp(24px, 3vw, 52px);\n    row-gap: 0;\n    grid-template-columns: minmax(0, 1.85fr) minmax(340px, 1fr);\n    margin-top: 14px;\n}\n\n.product-gallery {\n    min-width: 0;\n    position: relative;\n}\n\n.product-gallery__grid {\n    display: grid;\n    gap: clamp(8px, .85vw, 14px);\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.product-gallery__item {\n    appearance: none;\n    background: #f1f1f1;\n    border: 0;\n    cursor: zoom-in;\n    display: block;\n    overflow: hidden;\n    padding: 0;\n    width: 100%;\n}\n\n.product-gallery__image {\n    aspect-ratio: 1 / 1;\n    display: block;\n    object-fit: contain;\n    width: 100%;\n}\n\n.product-info {\n    align-self: start;\n    padding: clamp(36px, 3.5vw, 68px) clamp(8px, 2vw, 34px);\n    position: sticky;\n    top: 132px;\n}\n\n.product-info__brand {\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    margin-bottom: 6px;\n    text-transform: uppercase;\n}\n\n.product-info__title {\n    font-family: var(--mg-sans);\n    font-size: clamp(20px, 1.8vw, 28px);\n    font-weight: 400;\n    line-height: 1.25;\n    margin: 0;\n}\n\n.product-condition,\n.product-size,\n.product-availability {\n    color: #625f5a;\n    font-size: 14px;\n    line-height: 1.6;\n}\n\n.product-condition {\n    margin: 8px 0 0;\n}\n\n.product-price {\n    font-size: 17px;\n    font-weight: 500;\n    margin-top: 16px;\n}\n\n.product-size {\n    border-bottom: 1px solid rgba(17, 17, 17, 0.1);\n    margin: 12px 0 0;\n    padding-bottom: 14px;\n}\n\n.product-availability {\n    margin-top: 12px;\n}\n\n.product-availability p {\n    margin: 0 0 10px;\n}\n\n.product-primary-action {\n    background: #111111;\n    border: 1px solid #111111;\n    color: #ffffff;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    min-height: 54px;\n    padding: 0 24px;\n    text-transform: uppercase;\n    width: 100%;\n}\n\n.product-primary-action:hover:not(:disabled) {\n    background: #ffffff;\n    border-color: #111111;\n    color: #111111;\n}\n\n.product-primary-action:disabled {\n    cursor: not-allowed;\n    opacity: 0.45;\n}\n\n.product-details {\n    border-top: 1px solid rgba(17, 17, 17, 0.1);\n    margin-top: 20px;\n    padding-top: 18px;\n}\n\n.product-info__heading {\n    align-items: start;\n    display: grid;\n    gap: 16px;\n    grid-template-columns: minmax(0, 1fr) auto;\n}\n\n.product-info__heading .favourite-button {\n    margin-top: -8px;\n}\n\n.product-details h2 {\n    font-size: 12px;\n    font-weight: 700;\n    letter-spacing: 0.12em;\n    margin: 0 0 8px;\n    text-transform: uppercase;\n}\n\n.product-details p {\n    color: #4f4c48;\n    font-size: 14px;\n    line-height: 1.55;\n    margin: 0;\n}\n\n.product-description {\n    color: #4f4c48;\n    font-size: 14px;\n    line-height: 1.55;\n}\n\n.product-details__meta {\n    border-top: 1px solid rgba(17, 17, 17, 0.1);\n    display: grid;\n    font-size: 13px;\n    gap: 7px 16px;\n    grid-template-columns: minmax(96px, auto) 1fr;\n    margin: 16px 0 0;\n    padding-top: 14px;\n}\n\n.product-details__meta dt {\n    color: #77736e;\n}\n\n.product-details__meta dd {\n    margin: 0;\n    text-align: right;\n}\n\np.product-description {\n    white-space: pre-line;\n}\n\n.product-description p,\n.product-description div,\n.product-description ul,\n.product-description ol,\n.product-description blockquote {\n    margin: 0 0 12px;\n}\n\n.product-description ul,\n.product-description ol {\n    padding-left: 20px;\n}\n\n.product-description h2,\n.product-description h3,\n.product-description h4 {\n    color: #111111;\n    margin: 18px 0 8px;\n}\n\n.product-description > :last-child {\n    margin-bottom: 0;\n}\n\n.product-description button {\n    background: transparent;\n    border: 1px solid rgba(17, 17, 17, 0.18);\n    color: #111111;\n    display: inline-flex;\n    font: inherit;\n    margin: 4px 8px 4px 0;\n    padding: 7px 10px;\n}\n\n.product-description a {\n    color: #111111;\n    text-decoration: underline;\n    text-underline-offset: 3px;\n}\n\n.product-modal {\n    align-items: center;\n    background: #f4f3f0;\n    display: flex;\n    inset: 0;\n    justify-content: center;\n    padding: 20px;\n    position: fixed;\n    z-index: 1000;\n    animation: product-modal-enter 0.45s ease both;\n}\n\n.product-modal__content {\n    align-items: center;\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    max-height: 100%;\n    max-width: none;\n    overflow: hidden;\n    position: relative;\n    touch-action: none;\n    width: 100%;\n}\n\n.product-modal__image {\n    display: block;\n    max-height: calc(100vh - 40px);\n    max-width: calc(100% - 180px);\n    object-fit: contain;\n    cursor: zoom-in;\n    transform: scale(1);\n    transform-origin: center;\n    transition: transform .65s cubic-bezier(.16,1,.3,1);\n    user-select: none;\n}\n\n.product-modal__content.is-zoomed .product-modal__image { cursor: zoom-out; transform: scale(1.65); }\n\n.product-modal__arrow,\n.product-modal__close {\n    align-items: center;\n    background: transparent;\n    border: 0;\n    border-radius: 0;\n    color: #111111;\n    cursor: pointer;\n    display: flex;\n    justify-content: center;\n    position: absolute;\n    transition: color .2s ease, opacity .2s ease;\n    z-index: 1;\n}\n\n.product-modal__arrow:hover,\n.product-modal__close:hover {\n    background: transparent;\n    color: #111111;\n    opacity: .5;\n}\n\n@keyframes product-modal-enter {\n    from { opacity: 0; }\n    to { opacity: 1; }\n}\n\n.product-modal__arrow {\n    background: transparent;\n    border: 0;\n    height: 42px;\n    position: static;\n    width: 42px;\n}\n\n.product-modal__arrow svg { height: 25px; stroke-width: 1.8; width: 25px; }\n.product-modal__navigation { bottom: 20px; display: flex; flex-direction: column; gap: 2px; position: absolute; right: 18px; z-index: 3; }\n\n.product-modal__close {\n    height: 40px;\n    right: 18px;\n    top: 18px;\n    width: 40px;\n}\n\n@media (max-width: 820px) {\n    .product-page {\n        padding: 16px 12px 40px;\n    }\n\n    .product-layout {\n        grid-template-columns: 1fr;\n    }\n\n    .product-info {\n        padding: 12px 6px 0;\n        position: static;\n    }\n\n    .product-gallery__grid {\n        display: flex;\n        gap: 8px;\n        overflow-x: auto;\n        scroll-snap-type: x mandatory;\n        scrollbar-width: none;\n    }\n\n    .product-gallery__grid::-webkit-scrollbar {\n        display: none;\n    }\n\n    .product-gallery__item {\n        flex: 0 0 88%;\n        scroll-snap-align: start;\n    }\n}\n\n.product-modal__close svg { height: 25px; stroke-width: 1.8; width: 25px; }\n\n.product-modal__thumbnails { align-items: stretch; background: transparent; display: flex; flex-direction: column; gap: 18px; left: 18px; max-height: calc(100% - 64px); overflow-x: hidden; overflow-y: auto; overscroll-behavior: contain; padding: 0 8px 0 0; position: absolute; scrollbar-width: none; top: 50%; transform: translateY(-50%); width: 92px; z-index: 2; }\n.product-modal__thumbnails::-webkit-scrollbar { display: none; }\n.product-modal__thumbnail { background: transparent; border: 0; border-left: 2px solid transparent; cursor: pointer; flex: 0 0 104px; height: 104px; opacity: .48; overflow: hidden; padding: 0 0 0 7px; transition: border-color .25s ease, opacity .25s ease; width: 82px; }\n.product-modal__thumbnail:hover { opacity: .82; }\n.product-modal__thumbnail.is-active { border-left-color: #171717; opacity: 1; }\n.product-modal__thumbnail img { height: 100%; object-fit: contain; width: 100%; }\n\n@media (max-width: 540px) {\n    .product-layout {\n        gap: 20px;\n        margin-top: 12px;\n    }\n\n    .product-modal {\n        padding: 8px;\n    }\n\n    .product-modal__arrow {\n        height: 40px;\n        width: 40px;\n    }\n\n    .product-modal__image { max-height: calc(100dvh - 16px); max-width: calc(100% - 68px); }\n    .product-modal__thumbnails { gap: 10px; left: 2px; max-height: calc(100% - 40px); padding-right: 4px; width: 60px; }\n    .product-modal__thumbnail { flex: 0 0 68px; height: 68px; padding-left: 4px; width: 56px; }\n    .product-modal__navigation { bottom: 8px; right: 4px; }\n    .product-modal__close { right: 4px; top: 4px; }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .product-modal__arrow,\n    .product-modal__close {\n        transition: none;\n    }\n\n    .product-modal {\n        animation: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
